var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortreacttableau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6625 6.79797V11.2313H6.51245V12.5105H10.6625V16.9439H12.0302V12.5105H16.2125V11.2261H12.0302V6.79797H10.6625Z",
    fill: "#EB9129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6196 16.2698V19.352H29.8196V20.4812H32.6196V23.6218H33.852V20.4812H36.6676V19.352H33.852V16.2698H32.6196Z",
    fill: "#5C6692"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8946 6.71771V11.226H23.7875V12.5104H27.8946V16.9385H29.3436L29.353 14.7417L29.3863 12.5552L31.4208 12.5219L33.4446 12.5104V11.226H29.3436V6.71771H27.8946Z",
    fill: "#5B879B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5166 3.57605V6.63542H16.7833V7.43855H19.5166V10.4979H20.4885V7.43855H23.2218V6.63542H20.4885V3.57605H19.5166ZM6.07395 16.449V19.4708H3.33331V20.3333H6.07395V23.3833H7.00206V20.3333H9.78018V19.4708H6.95831V16.449H6.07395Z",
    fill: "#7199A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5823 22.7385V27.2468H6.47504V28.5333H10.5823V32.9657H12.1115V28.5333H16.2125V27.2468H12.1115V22.7333H11.348L10.5823 22.7385Z",
    fill: "#C72037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1156 19.1083V14.1177H20.896V19.1083H25.4906V20.7583H20.896V25.7552H19.1156V20.7583H14.5272V19.1083H19.1156Z",
    fill: "#E8762D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3542 32.1563V29.0968H20.6458V32.1563H23.424V33.2781H20.6833L20.6625 34.8688L20.6458 36.4198H19.3542V33.2781H16.6199V32.1563H19.3542Z",
    fill: "#5C6692"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8947 22.7272V27.2468H23.7V28.5333H27.8947V32.9968H29.3812V28.5333H33.526V27.2468H29.3812V22.7272H27.8947Z",
    fill: "#1F457E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortreacttableau);
export default __webpack_public_path__ + "static/media/port.react.tableau.582f6f65cea2ecefd00a9a58a53253ed.svg";
export { ForwardRef as ReactComponent };